/**
 * Holt die Laufzeitkonfiguration des Kundenstacks (ADR-044).
 *
 * Ein Build für alle Kunden; was den Kunden ausmacht, kommt von seinem eigenen
 * Ursprung. Diese Datei ist der einzige Ort im Portal, der sie abruft.
 */

import {
  lesePortalKonfiguration,
  OHNE_KONFIGURATION,
  type PortalKonfiguration,
} from "@hwc/config";

/** Absolut vom Wurzelpfad, nicht relativ: Die Shell hat Unterrouten. */
const PFAD = "/portal-konfiguration.json";

export interface Ladeergebnis {
  readonly konfiguration: PortalKonfiguration;
  /** Was gefehlt hat — für den Hinweis in der Shell. */
  readonly fehlend: readonly string[];
  /** Gesetzt, wenn die Datei gar nicht kam. */
  readonly fehler: string | null;
}

export async function ladeKonfiguration(): Promise<Ladeergebnis> {
  try {
    // `no-store` ist Auflage 4 aus ADR-044. Ohne sie zeigt ein Browser nach
    // dem Ausrollen noch die alten Merkmale - und ein abgeschaltetes Merkmal,
    // das weiter erscheint, ist ein Fehlerbild ohne erkennbare Ursache.
    const antwort = await fetch(PFAD, { cache: "no-store" });
    if (!antwort.ok) {
      return {
        konfiguration: OHNE_KONFIGURATION,
        fehlend: [],
        fehler: `${PFAD} antwortet mit ${antwort.status}`,
      };
    }
    const { konfiguration, fehlend } =
      lesePortalKonfiguration(await antwort.json());
    return { konfiguration, fehlend, fehler: null };
  } catch (ursache) {
    // Netzfehler oder kaputtes JSON. Die Shell läuft trotzdem an - eine
    // Oberfläche, die im Störungsfall weiß bleibt, ist genau dann unbrauchbar,
    // wenn man sie braucht.
    return {
      konfiguration: OHNE_KONFIGURATION,
      fehlend: [],
      fehler: ursache instanceof Error ? ursache.message : String(ursache),
    };
  }
}
